<template>
	<div class="welcome">
		<header class="navbar navbar-dark sticky-top bg-entity flex-md-nowrap p-0 shadow">
			<span class="navbar-brand col-md-3 col-lg-2 me-0 px-3 fs-6">Suscripcion ACES Chile</span>
			<button class="navbar-toggler position-absolute d-md-none collapsed" type="button" data-bs-toggle="collapse"
				data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false"
				aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>

			<div class="collapse navbar-collapse px-3 py-2 text-white d-md-block" id="sidebarMenu">
				<div class="d-flex flex-wrap align-items-center justify-content-end justify-content-lg-end">
					<ul class="nav col-12 col-lg-auto my-2 justify-content-center my-md-0 text-small">
						<li v-if="deliverNewSubscription && false">
							<span to="/newsubscription" class="nav-link text-muted"
								title="Suscripciones para el ultimo trimestre">
								<svg class="bi d-block mx-auto mb-1" width="24" height="24">
									<use xlink:href="#cart4" />
								</svg>
								Julio
							</span>
						</li>
						<li v-if="deliverNewSubscription && false">
							<span to="/newsubscription" class="nav-link text-muted"
								title="Suscripciones por los 2 ultimos trimestres">
								<svg class="bi d-block mx-auto mb-1" width="24" height="24">
									<use xlink:href="#cart4" />
								</svg>
								Abril
							</span>
						</li>
						<li v-if="deliverNewSubscription && false">
							<span to="/newsubscription" class="nav-link text-muted"
								title="Suscripciones por los 3 ultimos trimestres">
								<svg class="bi d-block mx-auto mb-1" width="24" height="24">
									<use xlink:href="#cart4" />
								</svg>
								Enero
							</span>
						</li>
						<li v-if="deliverNewSubscription">
							<router-link to="/newsubscription" class="nav-link text-entity-fuerza">
								<svg class="bi d-block mx-auto mb-1" width="24" height="24">
									<use xlink:href="#cart4" />
								</svg>
								Suscripción 2025
							</router-link>
						</li>
						<li v-if="reportVisible">
							<router-link to="/reports" class="nav-link text-entity-fuerza">
								<svg class="bi d-block mx-auto mb-1" width="24" height="24">
									<use xlink:href="#speedometer2" />
								</svg>
								Informes
							</router-link>
						</li>
						<li>
							<router-link to="/subscriptions" class="nav-link text-white">
								<svg class="bi d-block mx-auto mb-1" width="24" height="24">
									<use xlink:href="#table" />
								</svg>
								Suscripciones Ingresadas
							</router-link>
						</li>
						<li v-if="deliverVisible">
							<router-link to="/deliveries" class="nav-link text-white">
								<svg class="bi d-block mx-auto mb-1" width="24" height="24">
									<use xlink:href="#signpost-2" />
								</svg>
								Entregar
							</router-link>
						</li>
						<li>
							<router-link to="/downloads" class="nav-link text-white">
								<svg class="bi d-block mx-auto mb-1" width="24" height="24">
									<use xlink:href="#download" />
								</svg>
								Descargas
							</router-link>
						</li>
						<li>
							<router-link to="/profile" class="nav-link text-white">
								<svg class="bi d-block mx-auto mb-1" width="24" height="24">
									<use xlink:href="#people-circle" />
								</svg>
								Mis Datos
							</router-link>
						</li>
						<li>
							<router-link to="/logout" class="nav-link text-white">
								<svg class="bi d-block mx-auto mb-1" width="24" height="24">
									<use xlink:href="#exit" />
								</svg>
								Salir
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</header>
		<main class="container mt-2 p-3">
			<router-view></router-view>
		</main>
	</div>
</template>

<script>
import mixin from '@/mixins'
export default {
	name: 'Welcome',
	mixins: [mixin],
	computed: {
		deliverNewSubscription() {
			return this.getPeriod.length > 0
		},
		deliverVisible() {
			return true//this.getClientSystem.extras.cpil
		},
		reportVisible() {
			return this.getClientSystem.extras.cpil
		}
	},
}
</script>

<style></style>
